import { Tooltip } from "@repo/design-system/components/ui";
import { Icon } from "@iconify/react";
import PropTypes from 'prop-types';
import { forwardRef } from "react";

export const Iconify = forwardRef(({ icon, width = 20, style, className = "",
    altText = "icon", ttLabel, targetId, ttPosition, ...other }, ref) => {

    return (
        <>
            <Tooltip label={ttLabel} targetId={targetId} position={ttPosition} />
            <div ref={ref} className={`component-iconify ${className ?? ""}`} id={targetId}
                style={{ width, height: width, display: "flex", alignItems: "center", ...style }}
                {...other}>
                {
                    other.loader ? (
                        <Icon icon="codex:loader" width={width} height={width} />
                    ) : icon ? (
                        <Icon icon={icon} width={width} height={width} />
                    ) : (
                        <div style={{
                            width, height: width,
                            display: "flex", alignItems: "center", justifyContent: "center"
                        }}>
                            {altText}
                        </div>
                    )}
            </div>
        </>
    );
}
);

Iconify.propTypes = {
    icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    style: PropTypes.object,
    width: PropTypes.number,
    className: PropTypes.string,
    altText: PropTypes.string,
    ttLabel: PropTypes.string,
    ttPosition: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
    targetId: PropTypes.string
};
